import { render, staticRenderFns } from "./product-model.vue?vue&type=template&id=ca5024b4&scoped=true"
import script from "./product-model.vue?vue&type=script&lang=js"
export * from "./product-model.vue?vue&type=script&lang=js"
import style0 from "./product-model.vue?vue&type=style&index=0&id=ca5024b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5024b4",
  null
  
)

export default component.exports